// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import AppLogoImg from '../../../components/Utils/AppLogoImg'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import FormValidationError from "../../../components/InitialConfig/FormValidationError";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Cars
const Cars = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){

      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - COCHE', "", "")
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("CARS")        
      
      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("cars").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.title = "HELIAS - Configuración inicial: Coche"
      }
    }
  }, []);

  const [car, setAppCar] = useState("")
  const [illustrationElements, setIllustrationElements] = useState([])

  function procesarConfiguracionActual(jsonRespuesta){

    if(jsonRespuesta.Cars.toString().length > 0){ 
            
      var configuracionPasoActual = jsonRespuesta.Cars

      document.getElementById("selectTipoCoche").value = configuracionPasoActual.CarType;              
      
      if(configuracionPasoActual.CarID !== ""){
        var datosCoche = configuracionPasoActual.CarID.split("|")
        setAppCar(datosCoche[0]) 
        document.getElementById("carSpan").innerHTML = datosCoche[datosCoche.length-1]
        document.getElementById("car").value = datosCoche[0]+"|"+datosCoche[1]+"|"+datosCoche[2]
        document.getElementById("carFieldsetSinConfigurar").style="display: none"
        document.getElementById("carFieldsetSeleccionado").style="display"
      }  

      document.getElementById("labelCheckboxCargaEnInstalacion").className = document.getElementById("labelCheckboxCargaEnInstalacion").className.replaceAll(" hidden", "")

      if(configuracionPasoActual.ChargesInInstallation === "true"){
        document.getElementById("checkboxCargaEnInstalacion").checked = true        
      }
      else{
        document.getElementById("checkboxCargaEnInstalacion").checked = false
      }
      
      document.getElementById("botonEliminarConfiguracion").className = document.getElementById("botonEliminarConfiguracion").className.replaceAll(" hidden", "")

    }
    
    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))
 
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,    
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            procesarConfiguracionActual(jsonRespuesta.body)     
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);   
      
  }

  function actualizarFormularioTipoCoche(tipoCoche){

    if(tipoCoche === "ELECTRICO"){
      setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "CAR_CHARGER"))
    }
    else if(tipoCoche === "HIBRIDO"){
      setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "agregar", "CAR_CHARGER"))
    }else{
      setIllustrationElements(initialConfigCommonJS.modificarIlustracion(illustrationElements, "quitar", "CAR_CHARGER"))
    }

  }

  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0
    
    document.getElementById("carLink").className = "link"
    
    if(document.getElementById("car").value === ""){
      numeroErroresValidacion++
      document.getElementById("carLink").className += " error"
    }
   
    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
      
    //Preparo los datos necesarios para el json
  
    document.getElementById("loaderCars").className="loader overlay"

    var cargaEnInstalacion = "false"

    if(document.getElementById("checkboxCargaEnInstalacion").checked === true){
      cargaEnInstalacion = "true"
    }
    else{
      cargaEnInstalacion = "false"
    }
  
    var jsonCars = {    
      "CarType": document.getElementById("selectTipoCoche").value,
      "CarID": document.getElementById("car").value+"|"+document.getElementById("carSpan").innerHTML,
      "ChargesInInstallation": cargaEnInstalacion
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Cars": jsonCars
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")
            
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "CARS" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente, estoy conectándome a los sistemas configurados así que puede que los cambios tarden un par de minutos en reflejarse.","positive")
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderCars").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);    
      
  }
  
  function navegar(direccion){      
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        if(validacionCamposCorrecta()){    
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "CARS"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"CARS"}/>

      <section id="cars" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">

          <StepIntro 
            Title="Coche" 
            Intro={<p>¿Tienes coche y puedes ver su estado a través de una aplicación móvil? Regístralo y podré ayudarte con el control del consumo y si es eléctrico a cargarlo de forma desatendida con tus paneles solares.</p>}
          />  

          <fieldset>

            <fieldset className="two-columns">
              <fieldset className="dropdown hidden">
                <label htmlFor="selectTipoCoche">Tipo de coche</label>
                <div className="icon-wrapper">
                  <select id="selectTipoCoche" onChange={() => actualizarFormularioTipoCoche(document.getElementById("selectTipoCoche").value)}>
                    <option value="ELECTRICO">Eléctrico</option>
                    {/*
                    <option value="HIBRIDO">Híbrido</option>
                    <option value="GASOIL">Gasoil</option>
                    <option value="GASOLINA">Gasolina</option>
                    */}
                  </select>
                </div>
              </fieldset>
            </fieldset>

            <fieldset id="carFieldsetSinConfigurar">              
              <span className="size-l">Aplicación del coche</span>             
              <button id="carLink" className="link" onClick={() => initialConfigCommonJS.configurarDispositivo("car")}><span className="material-icon">add_circle</span>Seleccionar aplicación</button>
            </fieldset>

            <fieldset id="carFieldsetSeleccionado" style={{display: "none"}}>
              <span className="size-l">Aplicación del coche</span>             
              <div className="selector icon-wrapper no-icon">
                <div className="horizontal vertical-center gap-04 fill" onClick={() => initialConfigCommonJS.configurarDispositivo("car")}>
                  <figure className="avatar size-m"><AppLogoImg id="carLogoApp" aplicacion={car}/></figure>
                  <span id="carSpan" className="label"></span>
                </div>
                <input type="text" id="car" style={{display: "none"}}/>
              </div>
            </fieldset>

            <fieldset id="fieldsetCargaEnInstalacion" className="check multiple toggle green">
              <input type="checkbox" id="checkboxCargaEnInstalacion"/>
              <label id="labelCheckboxCargaEnInstalacion" className="icon-wrapper has-tooltip hidden" htmlFor="checkboxCargaEnInstalacion" >
                <span className="label" onClick={(event) => event.preventDefault()}>
                  <span>Mi coche carga en esta instalación</span>
                  <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                    <span className="tooltip top">
                      <span className="tooltip-container"><p className="size-m tooltip-title">Carga en instalación</p><p className="size-s">Marca esta opción si cargas tu coche en esta instalación. <strong>Si no la marcas configurarás el coche en modo consultivo</strong> y no estarán disponibles los controles de carga.</p></span>
                    </span>
                  </span>
                </span>
              </label>
            </fieldset>
            
         
          </fieldset>

          <FormValidationError/>

          <WorkflowNavigationButtons step={"CARS"} navegar={navegar}/>

        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderCars" Mensaje=""/>

      </section>

      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default Cars